import { formatNumberMix } from '@/utils'

export default {
  data() { },
  methods: {
    setCardOptions(data = []) {
      let list = new Array(4).fill(null)
      data = data.length && data[0]
      this.newCustomerNum = (data && data.newCustomerNum) || 0
      this.reorderCustomerNum = (data && data.reCustomerNum) || 0
      list[0] = {
        title: this.$t('customer::profits::totalCustomerNum'),
        count: data && this.$dataCheck(formatNumberMix(data.totalCustomerNum, '', ',')),
        down: data && data.totalCustomerNumRatio ? data.totalCustomerNumRatio < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.totalCustomerNumRatio, 2, '', '')),
        icon: 'icontubiaoku-11',
      }
      list[1] = {
        title: this.$t('customer::profits::customerNum'),
        count: data && this.$dataCheck(formatNumberMix(data.customerNum, '', ',')),
        down: data && data.customerNumRatio ? data.customerNumRatio < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.customerNumRatio, 2, '', '')),
      }
      list[2] = {
        title: this.$t('customer::profits::avgLtv'),
        count: data && this.$dataCheck(formatNumberMix(data.avgLtv, 2, ',', '')),
        down: data && data.avgLtvRatio ? data.avgLtvRatio < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.avgLtvRatio, 2, '', '')),
        icon: 'icontubiaoku-2'
      }
      list[3] = {
        title: this.$t('customer::profits::arpu'),
        count: data && this.$dataCheck(formatNumberMix(data.arpu, 2, ',')),
        down: data && data.arpuRatio ? data.arpuRatio < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.arpuRatio, 2, '', '')),
        icon: 'icontubiaoku-12'
      }
      return list
    },
    setCardReportOptions(data = []) {
      data = data.length && data[0]
      this.lossCustomerNum = (data && data.lossCustomerNum) || 0
      return {
        title: this.$t('customer::profits::average'),
        cardItems: [
          {
            title: this.$t('customer::profits::avgReOrderDay'),
            number: data && this.$dataCheck(formatNumberMix(data.avgReOrderDay, 2, '', '')),
            // icon: 'iconData-Sale',
            rate: data && this.$dataCheck(formatNumberMix(data.avgReOrderDayRatio, 2, '', '')),
            tooltip: false
          },
          {
            title: this.$t('customer::profits::avgReOrderNum'),
            // icon: 'iconData-Fee',
            number: data && this.$dataCheck(formatNumberMix(data.avgReOrderNum, 2, '', '')),
            rate: data && this.$dataCheck(formatNumberMix(data.avgReOrderNumRatio, 2, '', '')),
            tooltip: false
          },
          {
            title: this.$t('customer::profits::avgOrderNum'),
            // icon: 'iconData-ROI',
            number: data && this.$dataCheck(formatNumberMix(data.avgOrderNum, 2, '', '')),
            rate: data && this.$dataCheck(formatNumberMix(data.avgOrderNumRatio, 2, '', '')),
            tooltip: false
          }
        ]
      }
    },
    setCustomerAttribute(data = []) {
      return {
        title: this.$t('customer::profits::attributeEchart'),
        type: 'ring',
        ref: 'attributeEchart',
        height: '325px',
        tip: '',
        chart: {
          legend: {
            type: 'scroll',
            bottom: '4%',
            left: 'center'
          },
          tooltip: {
            trigger: 'item',
            formatter: (params, ticket, callback) => {
              return `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params.color}"></span><span>${params.name}  </span><span style="font-weight:900;">${params.value}</span><br/>
                            <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;"></span><span>占比  </span><span style="font-weight:900;">${params.data.rate}%</span>`
            }
          },
          series: [
            {
              type: 'pie',
              radius: ['50%', '70%'],
              label: {
                show: false,
                position: 'left'
              },
              itemStyle: {
                normal: {
                  labelLine: {
                    show: false
                  }
                }
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: '12'
                }
              },
              labelLine: {
                show: false
              },
              data: data.map(item => {
                return {
                  value: item.num,
                  rate: item.percent,
                  name: item.type
                }
              })
            }
          ]
        }
      }
    },
    setCustomerNewTrend(data = []) {
      return {
        type: 'line',
        title: this.$t('customer::profits::newTrend'),
        ref: 'lineChart',
        height: '325px',
        chart: {
          xAxis: {
            data: data.map(item => item.dtMonth)
          },
          yAxis: [
            {
              type: 'value',
              splitLine: {
                lineStyle: {
                  color: '#999999',
                  type: 'dashed'
                }
              },
              min: 0,
              axisLabel: {
                margin: 16,
                color: '#999999'
              }
            }
          ],
          series: [
            {
              type: 'line',
              name: this.$t('customer::profits::新客数'),
              data: data.map(item => Number(item.newCustomerNum))
            }
          ]
        }
      }
    },
    setCustomerReorder(data = []) {
      return {
        type: 'funnel',
        // tip: str,
        title: this.$t('customer::profits::reorder'),
        ref: 'funnelChartVistor',
        height: '325px',
        chart: {
          legend: {
            type: 'scroll',
            bottom: '0%',
            left: 'center',
            orient: 'horizontal',
            data: data.map(item => item.name)
          },
          tooltip: {
            trigger: 'item',
            formatter: '{b} : {c}%'
          },
          series: [
            {
              type: 'funnel',
              left: '10%',
              top: 60,
              bottom: 60,
              width: '80%',
              min: 0,
              max: 100,
              sort: 'descending',

              label: {
                show: true,
                position: 'inside',
                formatter: item => `${item.name}：${item.value}%`
              },

              itemStyle: {
                normal: {
                  labelLine: {
                    show: false
                  }
                }
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: '12'
                }
              },
              labelLine: {
                show: false
              },
              data: data.map(item => ({
                value: (item.value * 100).toFixed(2),
                name: item.name
              }))
            }
          ]
        }
      }
    }
  }
}
